
export function useViewTracking() {
    const {$apiFetch} = useNuxtApp();

    const trackView = async (modelType: number, modelId: number) => {
        return $apiFetch('/v1/views', {
            params: {
                model_type: modelType,
                model_id: modelId,
            },
            method: 'POST'
        })
    }

    return {
        trackView,
    }
}